import type { Glossary } from "@brookbush/types";

import GlossaryCard from "./GlossaryCard";

interface GlossaryAlphabetSectionProps {
	alphabet: string;
	glossaries: Glossary[];
}

const GlossaryAlphabetSection = ({
	alphabet,
	glossaries,
}: GlossaryAlphabetSectionProps) => {
	return (
		<div
			key={alphabet}
			className="flex scroll-m-20 flex-col gap-6"
			id={alphabet.toUpperCase()}
		>
			<h2 className="sticky top-28 max-w-max font-bold text-4xl text-sky-700 md:text-5xl dark:text-sky-200">
				{alphabet.toUpperCase()}
			</h2>

			<div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
				{glossaries.map((glossary: Glossary) => (
					<GlossaryCard
						description={glossary.description}
						id={glossary._id}
						slug={glossary.slug}
						title={glossary.title}
						key={glossary._id}
					/>
				))}
			</div>
		</div>
	);
};

export default GlossaryAlphabetSection;
